<template>
	<div class="region language-switcher">
		<button class="btn btn-plain trigger" v-click-outside="hide" @click="toggle" v-text="currentLanguage"></button>
		<div :class="(opened) ? 'list active' : 'list'" v-show="opened">
			<ul class="list-unstyled">
				<li v-for="(language, key) in languages"><a :href="`/${key}`" :title="language.name" v-text="key"></a></li>
			</ul>
		</div>
	</div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
	name: 'LanguageSwitcher',
	data() {
		return {
			opened: false,
			currentLanguage: window.sharedData.locale
		}
	},
	props: {
		languages: Array|Object
	},
	methods: {
		toggle() {
			this.opened = true
			//this.$refs.region_list.classList.add('active')
		},

		hide() {
			this.opened = false
			//this.$refs.region_list.classList.remove('active')
		}
	},
	mounted () {
		this.popupItem = this.$el
	},
	directives: {
		ClickOutside
	}
}
</script>
